import { render, staticRenderFns } from "./ModalLabPromo.vue?vue&type=template&id=4d445301"
import script from "./ModalLabPromo.vue?vue&type=script&lang=js"
export * from "./ModalLabPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports